import { createSelectors } from "@/redux/helpers/selector";

import { MODULE } from "./constants";

export const [isFetchingUsersStatus, getUsers, getSelectedUsers, getUnSelectedUsers] =
  createSelectors(MODULE, ["isFetchingUsersStatus", "users", "selectedUsers", "unSelectedUsers"]);
